import { Base } from "ui/Scripts/source/framework/base";
import { CompanyListItem, ICompanyListItem } from "../company/companyListItem";
import { CompanyGroupEditItem, ICompanyGroupEditItem } from "./companyGroupEditItem";

export interface ICompanyGroupEdit {
    companyGroup: ICompanyGroupEditItem;
    companies: ICompanyListItem[];
}

export class CompanyGroupEdit implements ICompanyGroupEdit {
    companyGroup: CompanyGroupEditItem;
    companies: CompanyListItem[];

    constructor();
    constructor(obj: ICompanyGroupEdit);
    constructor(obj?: any) {
        this.companyGroup = new CompanyGroupEditItem(obj ? obj.companyGroup : null);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyListItem);
    }
}